export default "__VITE_ASSET__DVWmvIAX__"